/**
 * 이용약관
 */
import React, { Component } from 'react';

import { Container, Navbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';

class TermsCmp extends Component {
  componentDidMount = () => {
    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.props.history !== null && typeof (this.props.history) !== undefined) this.props.history.go(-1);
    });
  }

  render() {

    return (
      <>
        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          스쿨라이프 이용약관
        </Navbar>
        <Container style={{ paddingTop: '5rem', paddingBottom: '5rem' }}>
          <ul>
            <li>제1조(목적 등)
              <ol>
                <li>스쿨라이프 (www.school-life.co.kr) 서비스 약관('본 약관'이라 합니다)은 이용자가 ㈜아이디프로에서 제공하는 인터넷 관련 서비스 (이하 '서비스'라 합니다)를 이용함에 있어 이용자와 ㈜아이디프로의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.</li>
                <li>이용자가 되고자 하는 자가 ㈜아이디프로이 정한 소정의 절차를 거쳐서 본 페이지의 맨 아래 동의함 버튼을 누르면 본 약관에 동의하는 것으로 간주합니다. 본 약관에 정하는 이외의 이용자와 ㈜아이디프로의 권리, 의무 및 책임사항에 관해서는 전기통신사업법 기타 대한민국의 관련 법령과 상관습에 의합니다.</li>
              </ol>
            </li>
            <li>제2조(이용자의 정의)
              <ol>
                <li>'이용자'란 스쿨라이프에 접속하여 본 약관에 따라 스쿨라이프 회원으로 가입하여 ㈜아이디프로이 제공하는 '스쿨라이프' 서비스를 받는 자를 말합니다.</li>
              </ol>
            </li>
            <li>제3조(회원 가입)
              <ol>
                <li>이용자가 되고자 하는 자는 스쿨라이프가 정한 가입 양식에 따라 회원정보를 기입하고 확인 버튼을 누르는 방법으로 회원 가입을 신청합니다.</li>
                <li>스쿨라이프는 제1항과 같이 회원으로 가입할 것을 신청한 자가 다음 각 호에 해당하지 않는 한 신청한 자를 회원으로 등록합니다.
                  <ol>
                    <li>가입신청자가 본 약관 제6조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우. 다만 제6조 제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 스쿨라이프의 회원재가입 승낙을 얻은 경우에는 예외로 합니다.</li>
                    <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
                    <li>기타 회원으로 등록하는 것이 '스쿨라이프'의 기술상 현저히 지장이 있다고 판단되는 경우</li>
                  </ol>
                </li>
                <li>회원가입계약의 성립시기는 '스쿨라이프'의 승낙이 가입신청자에게 도달한 시점으로 합니다.</li>
                <li>회원은 제1항의 회원정보 기재 내용에 변경이 발생한 경우, 즉시 변경사항을 정정하여 기재하여야 합니다.</li>
              </ol>
            </li>
            <li>제4조(서비스의 제공 및 변경)
              <ol>
                <li>'스쿨라이프'는 이용자에게 아래와 같은 서비스를 제공합니다.
                  <ol>
                    <li>홈페이지를 통한 정보제공</li>
                    <li>스쿨라이프 프로그램 무료 업데이트 서비스</li>
                    <li>유지보수 계약시 서버관리</li>
                    <li>고객요청시 광고교환 서비스</li>
                  </ol>
                </li>
                <li>'스쿨라이프'은 그 변경될 서비스의 내용 및 제공일자를 제7조 제2항에서 정한 방법으로 이용자에게 통지하고, 제1항에 정한 서비스를 변경하여 제공할 수 있습니다.</li>
              </ol>
            </li>
            <li>제5조(서비스의 중단)
              <ol>
                <li>'스쿨라이프'는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있고, 새로운 서비스로의 교체 기타 '스쿨라이프'이 적절하다고 판단하는 사유에 기하여 현재 제공되는 서비스를 완전히 중단할 수 있습니다.</li>
                <li>제1항에 의한 서비스 중단의 경우에는 '스쿨라이프'는 제7조 제2항에서 정한 방법으로 이용자에게 통지합니다. 다만, '스쿨라이프'가 통제할 수 없는 사유로 인한 서비스의 중단(시스템 관리자의 고의, 과실이 없는 디스크 장애, 시스템 다운 등)으로 인하여 사전 통지가 불가능한 경우에는 그러하지 아니합니다.</li>
              </ol>
            </li>
            <li>제6조(이용자 탈퇴 및 자격 상실 등)
              <ol>
                <li>이용자는 '스쿨라이프'에 언제든지 자신의 회원 등록을 말소해 줄 것(이용자 탈퇴)을 요청할 수 있으며 '스쿨라이프'는 위 요청을 받은 즉시 해당 이용자의 회원 등록 말소를 위한 절차를 밟습니다.</li>
                <li>이용자가 다음 각 호의 사유에 해당하는 경우, '스쿨라이프'는 이용자의 회원자격을 적절한 방법으로 제한 및 정지, 상실시킬 수 있습니다.
                  <ol>
                    <li>가입 신청 시에 허위 내용을 등록한 경우</li>
                    <li>다른 사람의 '서비스' 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우</li>
                    <li>'서비스'를 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
                  </ol>
                </li>
                <li>'스쿨라이프'가 이용자의 회원자격을 상실시키기로 결정한 경우에는 회원등록을 말소합니다. 이 경우 이용자인 회원에게 회원등록 말소 전에 이를 통지하고, 소명할 기회를 부여합니다.</li>
              </ol>
            </li>
            <li>제7조(이용자에 대한 통지)
              <ol>
                <li>'스쿨라이프'가 특정 이용자에 대한 통지를 하는 경우 '스쿨라이프'에 등록된 메일주소로 할 수 있습니다.</li>
                <li>'스쿨라이프'가 불특정다수 이용자에 대한 통지를 하는 경우 일주일이상 '스쿨라이프' 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.</li>
              </ol>
            </li>
            <li>제8조(이용자의 개인정보보호)
              <ol>
                <li>'스쿨라이프'는 관련법령이 정하는 바에 따라서 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위하여 노력합니다. 이용자의 개인정보보호에 관해서는 관련법령 및 '스쿨라이프'가 정하는 '개인정보처리방침'에 정한 바에 의합니다.</li>
                <li>'스쿨라이프'는 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’에 따라 고유식별번호(주민등록번호, 운전면허번호, 여권번호, 외국인등록증번호)는 수집하지 않습니다.</li>
              </ol>
            </li>
            <li>제9조('스쿨라이프'의 의무)
              <ol>
                <li>'스쿨라이프'는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하기 위해서 노력합니다.</li>
                <li>'스쿨라이프'는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 구축합니다.</li>
                <li>'스쿨라이프'는 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.</li>
                <li>'스쿨라이프'는 이용자가 서비스를 이용함에 있어 '스쿨라이프'의 고의 또는 중대한 과실로 인하여 입은 손해를 배상할 책임을 부담합니다.</li>
              </ol>
            </li>
            <li>제10조(이용자의 ID 및 비밀번호에 대한 의무)
              <ol>
                <li>'스쿨라이프'가 관계법령, '개인정보처리방침'에 의해서 그 책임을 지는 경우를 제외하고, 자신의 ID와 비밀번호에 관한 관리책임은 각 이용자게 있습니다.</li>
                <li>이용자는 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.</li>
                <li>이용자는 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 '스쿨라이프'에 통보하고 '스쿨라이프'의 안내가 있는 경우에는 그에 따라야 합니다.</li>
              </ol>
            </li>
            <li>제11조(이용자의 의무)
              <ol>
                <li> 이용자는 다음 각 호의 행위를 하여서는 안됩니다.
                  <ol>
                    <li>회원가입신청 또는 변경시 허위내용을 등록하는 행위</li>
                    <li>'스쿨라이프'에 게시된 정보를 변경하는 행위</li>
                    <li>'스쿨라이프' 기타 제3자의 인격권 또는 지적재산권을 침해하거나 업무를 방해하는 행위</li>
                    <li>다른 회원의 ID를 도용하는 행위</li>
                    <li>정크메일(junk mail), 스팸메일(spam mail), 행운의 편지(chain letters), 피라미드 조직에 가입할 것을 권유하는 메일, 외설 또는 폭력인 메시지 ·화상·음성 등이 담긴 메일을 보내거나 기타 공서양속에 반하는 정보를 공개 또는게시하는 행위.</li>
                    <li>관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 등)의 전송 또는 게시하는 행위</li>
                    <li>컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 전자우편으로 발송하는 행위</li>
                    <li>스토킹(stalking) 등 다른 이용자를 괴롭히는 행위</li>
                    <li>다른 이용자에 대한 개인정보를 그 동의 없이 수집,저장,공개하는 행위</li>
                    <li>불특정 다수의 자를 대상으로 하여 광고 또는 선전을 게시하거나 스팸메일을 전송하는 등의 방법으로 '스쿨라이프'의 서비스를 이용하여 영리 목적의 활동을 하는 행위</li>
                    <li>'스쿨라이프'이 제공하는 서비스에 정한 약관 기타 서비스 이용에 관한 규정을 위반하는 행위</li>
                  </ol>
                </li>
                <li>제1항에 해당하는 행위를 한 이용자가 있을 경우 '스쿨라이프'은 본 약관 제6조 제2, 3항에서 정한 바에 따라 이용자의 회원자격을 적절한 방법으로 제한 및 정지, 상실시킬 수 있습니다.</li>
                <li>이용자는 사전 승낙 없이 상업적인 목적(SPAM)을 위하여 서비스를 이용할 수 없습니다.
                  <ol>
                    <li>법령 또는 기타 관련규정이 정한 상업적인 목적(SPAM)의 서비스 이용으로 발생하는 모든 결과에 대하여는 고객에게 모든 책임이 있습니다.</li>
                    <li>고객은 상업적인 목적(SPAM)으로 서비스 이용시 본 약관에 의거하여 서비스를 해지합니다.</li>
                  </ol>
                </li>
                <li>이용자는 그 귀책사유로 인하여 '스쿨라이프'나 다른 이용자가 입은 손해를 배상할 책임이 있습니다.</li>
              </ol>
            </li>
            <li>제12조(이용자의 스펨(SPAM)메시지 관리 의무)
              <ol>
                <li>이용자는 문자메세지 전송에 대하여 이동 전화 시스템의 최종고객으로부터 사전 동의를 받은후, 동의서 사본을 ㈜아이디프로(당사)에게 제출하여야 합니다. 단, 모든 회원의 사본을 직접 제출하기 힘든 경우, 서비스 이용자의 문자메세지 전송 담당자의 SPAM 메시지 관리 동의서로 이를 대신 할 수 있으나, 최종고객에게 제공되는 문자메시지의 내용에 관하여 SPAM 메시지 전송이 문제가 된 경우, 서비스 이용자는 이에 대한 모든 책임을 부담하며, ㈜아이디프로(당사)은 해당 사항에 관하여 책임을 지지 않습니다. 여기서 'SPAM 메시지'라 함은 최종 사용자의 의사와 관계없이 상업적인 목적을 가지고, 무작위로 귀사로부터 전송되는 모든 문자메시지를 말합니다.</li>
                <li>스팸(SPAM) 문자메세지 정의 규정
                  <ol>
                    <li>정보통신망법을 위반하여 전송한 경우</li>
                    <li>사전 수신동의를 하지 않은 고객에게 전송한 경우 (단, 비영리 목적의 일반 메시지는 제외)</li>
                    <li>영리 목적의 광고성 메시지를 야간시간에 전송한 경우 (야간시간: 당일 21시 ~ 익일 09시까지)</li>
                    <li>수신거부(동의철회 포함) 무료전화번호 기재 없이 전송한 경우</li>
                  </ol>
                </li>
                <li>영리목적 문자메세지 전송 규정
                  <ol>
                    <li>광고할 내용 앞에 "(광고)" 또는 "(성인광고)" 문구를 표시해야 하며, 광고전송자의 명칭을 밝혀야 합니다.</li>
                    <li>또한, 수신자가 비용을 들이지 않고 용이하게 수신거부를 할 수 있는 방법을 명시해야 합니다. 다만, 수신자의 동의를 얻었을 경우에는 해당되지 않습니다.</li>
                    <li>영리목적의 공고성 메시지는 당일 09시부터 21시내에 한여여 서비스가 가능합니다. 다만, 광고성 메시지 전송에 대해 수신자의 사전동의 획득 시 서면으로 야간(21 시 이후 ~ 익일 09시 이전) 시간대에 수신을 허용한다고 명시하였을 경우에는 전송이 가능합니다.</li>
                  </ol>
                </li>
                <li>본 계약에 의해 서비스 이용자가 제공하는 스펨(SPAM)메시지의 내용과 관련하여, 서비스 이용자의 최종 사용자 또는 제3자가 ㈜아이디프로(당사)에 대해 손해배상 등의 청구를 한 경우, 이에 대한 모든 책임은 서비스 이용자에게 있습니다.</li>
                <li>상기 규정에도 불구하고, 귀사에 의해 ㈜아이디프로(당사)에게 손해가 발생하거나, 배상 의무가 발생한 경우, 이로 인하여 발생한 모든 손해에 대해서는 서비스 이용자가 이를 배상합니다.</li>
                <li>서비스 이용자는 SPAM 메시지 발생 시 본 동의서에 의거하여, 문자메세지 이용 계약을 해지합니다.</li>
                <li>서비스 이용자는 무차별적인 SPAM메시지가 이동전화시스템으로 전송되지 않도록 선량한 관리자의 주의의무를 가지고 서비스를 이용해야 하고, 메시지 전송현황을 상시, 확인, 감독합니다.</li>
              </ol>
            </li>
            <li>제13조(공개게시물의 삭제)
              <ol>
                <li>이용자의 공개게시물의 내용이 다음 각 호에 해당하는 경우 '스쿨라이프'는 이용자에게 사전 통지 없이 해당 공개게시물을 삭제할 수 있고, 해당 이용자의 회원 자격을 제한, 정지 또는 상실시킬 수 있습니다.
                  <ol>
                    <li>다른 이용자 또는 제3자를 비방하거나 중상 모략으로 명예를 손상시키는 내용</li>
                    <li>공서양속에 위반되는 내용의 정보, 문장, 도형 등을 유포하는 내용</li>
                    <li>범죄행위와 관련이 있다고 판단되는 내용</li>
                    <li>다른 이용자 또는 제3자의 저작권 등 기타 권리를 침해하는 내용</li>
                    <li>기타 관계 법령에 위배된다고 판단되는 내용</li>
                    <li>종교적, 정치적 분쟁을 야기하는 내용으로서, 이러한 분쟁으로 인하여 스쿨라이프의 업무가 방해되거나 방해되리라고 판단되는 경우</li>
                  </ol>
                </li>
                <li>이용자의 공개게시물로 인한 법률상 이익 침해를 근거로, 다른 이용자 또는 제3자가 이용자 또는 '스쿨라이프'를 대상으로 하여 민형사상의 법적 조치 (예:고소, 가처분신청, 손해배상청구소송)를 취하는 동시에 법적 조치와 관련된 게시물의 삭제를 요청해오는 경우, '스쿨라이프'은 동 법적 조치의 결과 (예: 검찰의 기소, 법원의 가처분결정, 손해배상판결)가 있을 때까지 관련 게시물에 대한 접근을 잠정적으로 제한할 수 있습니다.</li>
              </ol>
            </li>
            <li>제14조(저작권의 귀속 및 이용제한)
              <ol>
                <li>'스쿨라이프'가 작성한 저작물에 대한 저작권 기타 지적재산권은 '스쿨라이프'에 귀속합니다.</li>
                <li>이용자는 '스쿨라이프'를 이용함으로써 얻은 정보를 '스쿨라이프'의 사전승낙 없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.</li>
              </ol>
            </li>
            <li>제15조(면책)
              <ol>
                <li>(주)아이디프로은 각 호의 해당하는 경우에는 손해배상을 하지 않습니다.
                  <ol>
                    <li>전시, 사변, 천재지변 또는 이에 준하는 국가비상사태 등 불가항력으로 서비스를 제공할 수 없는 경우</li>
                    <li>고객의 고의 또는 과실 등 고객의 귀책사유로 서비스를 제공할 수 없는 경우</li>
                    <li>전기통신서비스 특성상 불가피한 사유로 서비스 제공이 불가능하거나 관련 시스템(S/W 포함)의 변경, 교체 등을 위하여 일시적으로 서비스 제공을 중단하는 경우</li>
                    <li>고객의 귀책사유로 서비스가 해지 되어, 고객의 정보가 소실된 경우</li>
                    <li>이동통신 사업자측과 회선사업자의 불가피한 시스템상의 장애로 인하여 서비스를 정상적으로 제공하지 못하는 경우</li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>제16조(전자화폐 정책)
              <ol>
                <li>충전식 회원이 무통장입금 및 카드결재로 충전되어지는 금액은 SMS를 발송하기 위한 디지털화페로 전환되며 ㈜아이디프로에서 서비스가 불가능한 사유를 제외하고는 환불처리 되지 않습니다.</li>
                <li>회원이 타인의 결제수단을 이용하여 캐쉬를 구매할 경우, 회사는 이에 대한 책임을 지지 않습니다.</li>
                <li>캐쉬는 문자메시지 서비스를 이용하는 지불 수단으로 사용되며, 회사가 제공하는 문자메시지 서비스를 이용하는 시점에서 차감이 됩니다. 서비스상에 중대한 하자에 의해서 구매한 서비스가 불량했을 경우 재충전 혹은 서비스 복원으로 보상 받을 수 있습니다.</li>
                <li>증여 : 구매한 캐쉬는 회사가 별도로 지정하지 않는 한 타인에게 증여할 수 없습니다.</li>
                <li>환불 사유
                  <ol>
                    <li>회사가 지정한 결제 수단으로 캐쉬를 구매하였으나 충전이 이루어지지 않은 경우 환불을 요청 할 수 있습니다.</li>
                    <li>회사의 고의 또는 과실로 인해 캐쉬 구매 결제가 중복으로 발생한 경우. 단, 회원의 고의 또는 과실로 인해 캐쉬 충전이 중복으로 이뤄진 경우는 제외됩니다.</li>
                    <li>서비스 제공 중에 회사의 고의 또는 과실로 인해 서비스에 중대한 장애가 발생한 경우. 단, 정상적인 서비스 제공에 대한 대가는 환불 대상에서 제외됩니다.</li>
                    <li>그 외 회사가 회원의 환불요청 사유에 대해 정당하다고 판단하는 경우.</li>
                  </ol>
                </li>
                <li>환불을 원하는 회원은 회사의 "고객센터"또는 "콜센터"를 통하여 환불 신청이유를 회사에 통지하고 회원 본인이 직접 환불신청을 하여야 합니다.</li>
                <li>회사는 환불 신청이유를 심사한 후 환불 신청 이유에 따라 회원에게 약관에 따라 산정된 금액으로 회원으로 계좌에 현금입금의 방법으로 환불하여 드릴 수 있습니다.</li>
                <li>환불 신청시 결제금액에 따라 추가 증여된 캐쉬를 제외한 후 재정경제부에서 고시한 &gt;인터넷이용관련소비자피해보상&lt; 에서 규정한 위약금(총 이용료의 10%) 및 PG수수료, 송금비용, 부가세를 제외한 잔액을 환불하여 드립니다. 단, 위약금 및 PG수수료, 송금비용, 결제금액에 따라 추가 증여된 캐쉬의 합계는 최소 1,000원 입니다. 따라서 1,000원 미만의 금액은 회원 탈퇴시 자동 소멸됩니다.</li>
                <li>아래 사유로 이용종료(계약해지)처리 된 경우에는 캐쉬는 자동소멸됩니다.
                  <ol>
                    <li>회원의 귀책사유로 이용종료(계약해지)처리 된 경우</li>
                    <li>제11조(이용자의 의무), 제12조(이용자의 스펨(SPAM)메시지 관리 의무)에 따라 이용종료(계약해지)처리 된 경우</li>
                  </ol>
                </li>
                <li>캐쉬 충전 후 일정기간 사용이 없는 경우 상사소멸시효에 따라 소멸됩니다.
                  <ol>
                    <li>최초 서비스에 가입하여 캐쉬를 충전하고 12개월이 경과하는 동안 서비스를 이용하지 않는 고객아이디는(발송, 로그인기록이 없는)은 휴면계정으로 처리되어 회계상의 잡이익 계정으로 처리합니다.</li>
                  </ol>
                </li>
                <li>스팸 발송으로 인해 수신자의 스팸 신고가 접수되거나 ㈜아이디프로 스팸 필터링에 접수되는 경우 등 스팸으로 판단될 경우 해당 회원에 통보한 후 강제 탈퇴하는 것을 원칙으로 하며, 향후 서비스 이용이 불가합니다. 또한 ㈜아이디프로의 스팸관련 규약에 따라 잔여캐쉬는 금액에 상관없이 환불하지 않으며, 추가적으로 발생하는 ㈜아이디프로의 모든 손해는 "이용자"가 모두 책임집니다.</li>
                <li>서비스가 정상적으로 이루어지지 못한 경우, 사용한 캐쉬나 포인트를 최장 72시간 이내에 자동 재충전 처리되며, 기타 서비스의 문제 발생시 관리자의 확인절차 후 그 이유가 정당할 때 신속히 처리합니다.</li>
                <li>회사는 관계법령의 변경 등 합리적인 사유 발생 및 회사 정책상 변경이 필요한 경우, 캐쉬 및 마일리지 운영정책을 변경하여 운영할 수 있으며 해당 사실을 서비스에 공지합니다.</li>
              </ol>
            </li>
            <li>제17조(약관의 개정)
              <ol>
                <li>'스쿨라이프'는 약관의규제등에 관한 법률, 전자거래기본법, 전자서명법, 정보통신망이용촉진등에관한법률 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
                <li>'스쿨라이프'가 본 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 초기화면에 그 적용일자 칠(7일) 이전부터 적용일자 전일까지 공지합니다.</li>
                <li>'이용자'는 변경된 약관에 대해 거부할 권리가 있습니다. '이용자'는 변경된 약관이 공지된 후 십오(15)일 이내에 거부의사를 표명할 수 있습니다. '이용자'가 거부하는 경우 '스쿨라이프'는 당해 '이용자'와의 계약을 해지할 수 있습니다. 만약 '이용자'가 변경된 약관이 공지된 후 십오(15)일 이내에 거부의사를 표시하지 않는 경우에는 동의하는 것으로 간주합니다.</li>
              </ol>
            </li>
            <li>제18조(재판관할)
              <ul>
                <li>'스쿨라이프'와 이용자간에 발생한 서비스 이용에 관한 분쟁에 대하여는 대한민국 법을 적용하며, 본 분쟁으로 인한 소는 민사소송법상의 관할을 가지는 대한민국의 법원에 제기합니다.</li>
              </ul>
            </li>
            <li>부 칙
              <ul>
                <li>본 약관은 2006. 01. 02. 부터 적용됩니다.</li>
                <li>본 약관은 2012. 08. 16. 부터 시행하고, 2006.01.02. 부터 시행되던 종전의 약관은 본 약관으로 대체합니다.</li>
                <li>본 약관은 2020. 03. 09. 부터 시행하고, 2012.08.16. 부터 시행되던 종전의 약관은 본 약관으로 대체합니다.</li>
                <li>본 약관은 2020. 06. 22. 부터 시행하고, 2020.03.09. 부터 시행되던 종전의 약관은 본 약관으로 대체합니다.</li>
                <li>본 약관은 2024. 01. 23. 부터 시행하고, 2020.06.22. 부터 시행되던 종전의 약관은 본 약관으로 대체합니다.</li>
              </ul>
            </li>
          </ul>
        </Container>
      </>
    );
  }

}

export default TermsCmp;